var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92383 0H1.23077C0.551034 0 0 0.551034 0 1.23077V4.92187L1.84615 4.92187V1.84615H4.92383V0ZM11.0777 1.84615V0H14.7692C15.449 0 16 0.551034 16 1.23077V4.92188L14.1538 4.92187V1.84615H11.0777ZM1.84615 11.0757H0V14.7692C0 15.449 0.551034 16 1.23077 16H4.92383V14.1538H1.84615V11.0757ZM11.0777 14.1538V16H14.7692C15.449 16 16 15.449 16 14.7692V11.0757H14.1538V14.1538H11.0777Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55425 7.15815C9.15753 7.53899 8.61948 7.75294 8.05844 7.75294C7.49741 7.75294 6.95935 7.53899 6.56264 7.15815C6.16593 6.7773 5.94306 6.26077 5.94306 5.72218C5.94306 5.18358 6.16593 4.66705 6.56264 4.2862C6.95935 3.90536 7.49741 3.69141 8.05844 3.69141C8.61948 3.69141 9.15753 3.90536 9.55425 4.2862C9.95096 4.66705 10.1738 5.18358 10.1738 5.72218C10.1738 6.26077 9.95096 6.7773 9.55425 7.15815Z",
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4431 11.8145H4.67383C4.67383 10.9527 5.03042 10.1263 5.66516 9.51693C6.2999 8.90758 7.16079 8.56525 8.05844 8.56525C8.9561 8.56525 9.81699 8.90758 10.4517 9.51693C11.0865 10.1263 11.4431 10.9527 11.4431 11.8145Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLens);
export default __webpack_public_path__ + "static/media/icon-lens.bcdfe7a1cf586794fdccf2e93775e9a8.svg";
export { ForwardRef as ReactComponent };